const incrementAlphabeticalLetters = (i: number) =>
  String.fromCharCode("A".charCodeAt(0) + i);

export default incrementAlphabeticalLetters;
